/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PromptType;
(function (PromptType) {
    PromptType["OPEN_POSITION"] = "OPEN_POSITION";
    PromptType["GENERAL"] = "GENERAL";
})(PromptType || (PromptType = {}));
